import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Config from '@playlist/config';

import './index.css';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './app/store';

Sentry.init({ dsn: 'https://3683fbafcfac40df86c1ed80130b1e41@sentry.io/1554425' });
const tagManagerArgs = {
  gtmId: `${Config.web.GTM.id}`,
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
